import { createLucideIcon } from 'lucide-react';

// The glyph is a knockout in the disc, so it shows the surface behind the icon. A
// white disc below the coloured one fills the knockout with a fixed white. Its
// radius is 1 less, so no pale edge shows around the rim.

export const CircleAlertSolid = createLucideIcon('CircleAlertSolid', [
  [
    'circle',
    {
      key: 'circle-1',
      cx: '12.2',
      cy: '12',
      r: '10',
      fill: '#fff',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-1',
      d: 'M12.2 1a11 11 0 1 1 0 22 11 11 0 0 1 0-22M12 16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0-11q-1.4.2-1.5 1.5v6a1.5 1.5 0 0 0 3 0v-6Q13.4 5.2 12 5',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
